module.exports = __webpack_public_path__ + "static/media/icon-medicare-phone.f2dde201.png";